module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.isLoading),
      expression: "$store.state.isLoading"
    }],
    staticClass: "overlay top",
    style: (_vm.styleObject),
    attrs: {
      "id": "customOverlay"
    }
  }, [_c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.isLoading),
      expression: "$store.state.isLoading"
    }],
    attrs: {
      "size": 70,
      "width": 7,
      "color": "blue-grey",
      "indeterminate": ""
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-402d84b9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-402d84b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/components/overlay/overlay.vue.html
// module id = 587
// module chunks = 0